import { ApiV1Module } from '../define/api-v1';
import { createRequestUtil, HttpClient as _HttpClient } from './request';

type ApiConfig = ApiV1Module;

export { type HttpMethod } from './request';
export type HttpClient = _HttpClient;

let client: null | HttpClient = null;
export function initRequestClient(_client: HttpClient) {
  client = _client;
}

let url = '';
export function setBaseUrl(_url: string) {
  url = _url;
}

export const { request } = createRequestUtil<ApiConfig>(
  () => client,
  () => url,
  data => data.success,
);
